import { useMemo } from "react";

import api, { useSWR } from "../utils/axios";

const baseUrl = `/api/notification/`;

/*
  Registers this device's token and refreshes its last_seen heartbeat, upserting when the row is
  missing. Called on every app start, unlike add-token, which the clients only call when Firebase
  reports the token itself changed.
*/
export function touchToken(data) {
  return api.put(`${baseUrl}device-token/heartbeat`, {
    ...data,
  });
}

export function readAll(userId, request) {
  return api.put(`${baseUrl}${userId}`);
}

export function unread(id, request) {
  return api.put(`${baseUrl}unread/${id}`);
}

export function remove(id) {
  return api.delete(`${baseUrl}${id}`);
}

export function useGetList(userId) {
  const url = `${baseUrl}get-list/${userId}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(userId ? url : null);

  const memoizedValue = useMemo(
    () => ({
      notifications: data || [],
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
